document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.wcl-media').forEach(section => {
        const tabs     = section.querySelectorAll('.wcl-media__tab');
        const content  = section.querySelector('[data-media-content]');
        const postType = section.dataset.postType || 'video';
        const taxonomy = section.dataset.taxonomy  || 'video_category';

        if ( ! tabs.length || ! content ) return;

        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                if ( tab.classList.contains('is-active') ) return;

                tabs.forEach(t => {
                    t.classList.remove('is-active');
                    t.setAttribute('aria-selected', 'false');
                });
                tab.classList.add('is-active');
                tab.setAttribute('aria-selected', 'true');

                const category = tab.dataset.category;
                content.classList.add('is-loading');

                const body = new FormData();
                body.append('action',    'load_videos_by_category');
                body.append('nonce',     config.videos_nonce);
                body.append('category',  category);
                body.append('post_type', postType);
                body.append('taxonomy',  taxonomy);

                fetch(config.ajax_url, { method: 'POST', body })
                    .then(res => res.json())
                    .then(data => {
                        if ( data.success ) {
                            content.innerHTML = data.html;
                        }
                    })
                    .catch(() => {})
                    .finally(() => {
                        content.classList.remove('is-loading');
                    });
            });
        });
    });
});